export default {
  getGameData() {
    return this.get('/misc/game-data')
      .then((responseData) => responseData);
  },

  ping() {
    return this.get('/misc/ping')
      .then((responseData) => responseData.pong);
  },

  denyConsent(type, submissionToken) {
    return this.post('/misc/deny-consent', { type, submissionToken });
  },

  acceptConsent(type, submissionToken, email = null) {
    return this.post('/misc/accept-consent', { type, email, submissionToken });
  },

  sendReport(submissionToken, email, language) {
    return this.put('/misc/send-report', { submissionToken, email, language });
  },
};
